export var LocationType;
(function (LocationType) {
    LocationType[LocationType["STOCK"] = 1] = "STOCK";
    LocationType[LocationType["RECEIVING"] = 2] = "RECEIVING";
    LocationType[LocationType["SHIPPING"] = 3] = "SHIPPING";
    LocationType[LocationType["INSPECTION"] = 4] = "INSPECTION";
    LocationType[LocationType["LOCKED"] = 5] = "LOCKED";
    LocationType[LocationType["VENDOR_CONSIGNMENT"] = 6] = "VENDOR_CONSIGNMENT";
    LocationType[LocationType["CUSTOMER_CONSIGNMENT"] = 7] = "CUSTOMER_CONSIGNMENT";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=location-type.js.map